export default "__VITE_ASSET__DwPQYswl__"